import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const HomepageSlottingRBAC = {
  pageID: '274129d89d3ae33c3924b8b8b304fd71',
  elementID: {
    ViewList: 'd26b45f8477f02e45d2586ace24f855f',
    BulkUpload: 'd42d5f810a477335fd0ad96a44649d62',
  },
} as const

export const useRBACHomepageSlottingPage = createUseRBAC(HomepageSlottingRBAC.elementID)

export type UseRBACHomepageSlottingPageType = ReturnType<typeof useRBACHomepageSlottingPage>
